<template>
    <div>
            <b-row>
                <b-col cols="12">
                    <b-form-group :label="$t('card_holder_name')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.card_holder_name) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('card_type')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.card_type) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
                <b-col cols="12">
                    <b-form-group :label="$t('card_number')">
                        <b-input-group>
                            <div class="label-as-input">{{ isNotNullValue(form.card_number) }}</div>
                        </b-input-group>
                    </b-form-group>
                </b-col>
            </b-row>
    </div>
</template>

<script>
    //Service
    import CustomerCreditCardService from "@/services/CustomerCreditCardService";

    export default {
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                form: {
                    name: null,
                    code: null,
                }
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                CustomerCreditCardService.get(id)
                           .then((response) => {
                               this.form = response.data.data;
                           })
                           .catch((error) => {
                               this.showErrors(error)
                           });
            }
        }
    }
</script>
